import { alkymetricsClient } from '../alkymetricsClient';
import { Platforms } from '../../constants/enums';

export const updateNotification = async (workspaceId, partnerId, request) => {
  const { data } = await alkymetricsClient.patch(
    `/partner-to-workspace-to-notifications/${workspaceId}/${partnerId}`,
    request
  );
  return data;
};

export const getNotifications = async ({ limit = 15, nextId, read = 'all' }) => {
  const params = {
    limit,
    read,
    platform: Platforms.PARTNERS,
  };

  if (nextId) {
    params.nextId = nextId;
  }

  const { data } = await alkymetricsClient.get('/notification/me', { params });
  return data;
};

export const markNotificationAsRead = async (notificationId) => {
  const { data } = await alkymetricsClient.patch(`/notification/me/${notificationId}/read`);
  return data;
};

export const markNotificationsAsRead = async (notifications) => {
  const { data } = await alkymetricsClient.post('/notification/me/read', {
    notifications: notifications.map((notification) => ({
      id: notification.id,
      createdAt: notification.createdAt,
    })),
  });
  return data;
};

/**
 * Mark ALL unread notifications as read (no pagination limit)
 * @returns {Promise<{ markedCount: number }>}
 */
export const markAllNotificationsAsRead = async () => {
  const { data } = await alkymetricsClient.post('/notification/me/read', {
    notifications: [], // Array vacío = marcar TODAS
  });
  return data; // { markedCount: number }
};

export const deleteNotification = async (notificationId, createdAt) => {
  const { data } = await alkymetricsClient.delete(`/notification/me/${notificationId}`, {
    params: { date: createdAt },
  });
  return data;
};
